import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import Styled from 'styled-components';
import { Auth } from 'aws-amplify';
import { LogoutOutlined } from '@ant-design/icons';
import logo from '../assets/logo.png';

const { Header } = Layout;

async function signOut() {
  try {
    await Auth.signOut();
  } catch (error) {
    console.log('error signing out: ', error);
  }
}

async function userIsLoggedIn() {
  try {
    await Auth.currentAuthenticatedUser();
    return true;
  } catch {
    return false;
  }
}

const MainHeader = () => {
  const [userIsLogged, setUserIsLogged] = useState(false);
  // eslint-disable-next-line no-return-await
  const getUserStatus = async () => await userIsLoggedIn();

  useEffect(async () => {
    const user = await getUserStatus();
    setUserIsLogged(user);
  }, []);

  return (
    <Header>
      <div className="logo">
        <Logo>
          <Link to="/"><img src={logo} alt="Logo" width="50%" /></Link>
        </Logo>
      </div>
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
        {/* <Menu.Item key="1"> */}
        {/*  <Link to="/">Accueil</Link> */}
        {/* </Menu.Item> */}
        <Menu.Item key="2">
          <Link to="/calculateur-simulant">Calculateur</Link>
        </Menu.Item>
        {/* <Menu.Item key="3"> */}
        {/*  <Link to="/recipe_result">Recette</Link> */}
        {/* </Menu.Item> */}
        <Menu.Item key="4">
          <Link to="/recipes">Mes recettes</Link>
        </Menu.Item>
        {/*        <Menu.Item key="5">
          <Link to="/orders">Mes Devis</Link>
        </Menu.Item> */}
        {userIsLogged && (
          <Menu.Item onClick={signOut} key="logout">
            <LogoutOutlined />
          </Menu.Item>
        )}
      </Menu>
    </Header>
  );
};

const Logo = Styled.div`
  height: 60px;
  margin: 2px 0px 2px 0px;
  text-align: center;
`;

export default MainHeader;
